import React, { useState } from "react";
import { cleanedString } from "../../../Helper/Calculation";
import { useAccessCard } from "../../../ContextProvider/Accesscardprovider";

const Quizquestion = ({
  questions, selectedOptions, setSelectedOptions,
  showReviewPanel, setShowReviewPanel,
  quiz, index, setQuiz, setIndex
}) => {
  let correctCount=0
  const { setMarks, setAnswer, accessCard, accessQuizSubmit } = useAccessCard();
  const totalQuestions = questions.length;
  const [showHint, setShowHint] = useState(false); // hint toggle state

  // const CalculateMarks = () => {
  //   correctCount = selectedOptions.filter((val, idx) =>
  //     val !== null && cleanedString(val) === cleanedString(questions[idx].answer)
  //   ).length;
  //   console.log(correctCount)
  //   sessionStorage.setItem("qquizMarks", correctCount);
  //   sessionStorage.setItem("qquizAnswer", JSON.stringify(selectedOptions));
  // }

  const next = () => {
    // const correctCount = selectedOptions.filter((val, idx) =>
    //   val !== null && cleanedString(val) === cleanedString(questions[idx].answer)
    // ).length;

    // sessionStorage.setItem("qquizMarks", correctCount);
    // sessionStorage.setItem("qquizAnswer", JSON.stringify(selectedOptions));

    if (index < totalQuestions - 1) {
      setIndex(index + 1);
      setQuiz(questions[index + 1]);
      setShowHint(false); // reset hint on next
    } else {
      setMarks(correctCount);
      setAnswer(selectedOptions);
      accessCard();
      accessQuizSubmit();
    }
  };

  const previous = () => {
    if (index > 0) {
      setIndex(index - 1);
      setQuiz(questions[index - 1]);
      setShowHint(false); // reset hint on previous
    }
  };

  // const handleOptionChange = (optionIndex, optionText) => {
  //   const updatedSelections = [...selectedOptions];
  //   updatedSelections[index] = optionText;
  //   setSelectedOptions(updatedSelections);
  //   CalculateMarks()
  // };

  const handleOptionChange = (optionIndex, optionText) => {
  const updatedSelections = [...selectedOptions];
  updatedSelections[index] = optionText;
  setSelectedOptions(updatedSelections);

  // Calculate marks using updatedSelections
  const correctCount = updatedSelections.filter((val, idx) =>
    val !== null && cleanedString(val) === cleanedString(questions[idx].answer)
  ).length;

  sessionStorage.setItem("qquizMarks", correctCount);
  sessionStorage.setItem("qquizAnswer", JSON.stringify(updatedSelections));
};


  return (
    <div className="question-box-wrapper">
      <div className="question-box">
        <h3>{index + 1}. {cleanedString(quiz.question)}</h3>

        {quiz.hints && quiz.hints.trim() !== "" && (
          <>
            <button
              className="hint-toggle"
              onClick={() => setShowHint(!showHint)}
            >
              <b>{showHint ? "Hide Hint" : "Show Hint"}</b>
            </button>

            {showHint && (
              <div className="hint-box">
                <strong>Hint:</strong> {cleanedString(quiz.hints)}
              </div>
            )}
          </>
        )}

        <div
          className="question-body"
          dangerouslySetInnerHTML={{ __html: quiz.question_body }}
        />

        <div className="options">
          {[quiz.option1, quiz.option2, quiz.option3, quiz.option4].map((opt, i) => {
            const option = cleanedString(opt);
            return (
              <label key={i} className={`option ${selectedOptions[index] === option ? "selected" : ""}`}>
                <input
                  type="radio"
                  name={`question-${index}`}
                  checked={selectedOptions[index] === option}
                  onChange={() => handleOptionChange(i, option)}
                />
                {option}
              </label>
            );
          })}
        </div>
      </div>

      <div className="navigation">
        {index > 0 ? (
          <button className="review-btn" onClick={previous}>Previous</button>
        ) : <div />}
        <button className="review-btn" onClick={() => setShowReviewPanel(!showReviewPanel)}>
          Review
        </button>
        <button className="next-btn" onClick={next}>
          {index === totalQuestions - 1 ? "Submit" : "Next"}
        </button>
      </div>
    </div>
  );
};

export default Quizquestion;
